import { CButton, CCard, CCardBody, CCol, CForm, CInputGroup, CRow } from '@coreui/react'
import React, { useEffect, useRef, useState } from 'react'
import BaseListing from 'src/BaseListings'
import { wtApiCall } from '../../helpers/commons/ApiWrapper'
import { lzNotifyErrorMessageFromResult } from '../../helpers/commons/notifications'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'
import DataReportTable from './DataReportTable'
import Loading from 'src/helpers/commons/loader'
import { DatePicker } from 'antd'
import WidgetDesignationSelector from 'src/widgets/Selectors/WidgetDesignationSelector'
import WidgetBranchSelector from 'src/widgets/Selectors/WidgetBranchSelector'
const { RangePicker } = DatePicker
export default function OvertimeReport() {
  const Base = new BaseListing()
  const tableRef = useRef(null)
  const [isLoading, setIsLoading] = useState(false)
  const [reportData, setReportData] = useState([])
  const [range, setRange] = useState(null)
  const [branches, setBranches] = useState([])
  const [designations, setDesignations] = useState([])
  const [designation_id, setDesignationId] = useState(0)
  const [designation_name, setDesignationName] = useState('')
  const [branchId, setBranchId] = useState(0)
  const [branch_name, setBranchName] = useState('')
  // const { onDownload } = useDownloadExcel({
  //   currentTableRef: tableRef.current,
  //   filename: 'Overtime Report',
  //   sheet: 'Difference',
  // })
  const getReportData = () => {
    if (!range || range.length < 2) {
      lzNotifyErrorMessageFromResult("Please select a valid date range");
      return;
    }

    const fromDate = range[0];
    const toDate = range[1];
    setIsLoading(true);

    wtApiCall(
      'reports/contract_expiry_report',
      {
        fromDate: fromDate.format('YYYY-MM-DD'),
        toDate: toDate.format('YYYY-MM-DD'),
        branch_id: branchId,
        designation_id: designation_id,
      },
      'get',
      (response) => {
        setReportData(response.data);
        setIsLoading(false);
      },
      (error) => {
        lzNotifyErrorMessageFromResult(error);
        setIsLoading(false);
      },
    );
  };

  const changeValues = (key, val) => {

    if (key === 'designation_id') {
      setDesignationId(val.value)
      setDesignationName(val.label)
    }

    if (key === 'branch_id') {
      setBranchId(val.value)
      setBranchName(val.label)
    }
  }

  useEffect(() => {
    Base.dropdownData(
      'branches,designations',
      {},
      [setBranches, setDesignations],
      1,
    )
  }, [])
  return (
    <>
      <div style={{ padding: '2%' }}>
        <center>
          <h4>Contract Expiry Report</h4>
        </center>
        <CRow style={{ width: '100%' }}>
          <CCol md={12}>
            <CCard className="card-dark">
              <CCardBody style={{ backgroundColor: '#f7f9fa' }}>
                <br />
                <CForm>
                  <CRow style={{ alignItems: 'flex-end' }}>
                    {/* <CCol md={1}></CCol> */}
                    <CCol md={1}>
                      <CInputGroup>
                        <label style={{ fontSize: '140%', marginBottom: '8px' }}>Filters:</label>
                      </CInputGroup>
                    </CCol>
                    <CCol md={2}>
                      <div className="form-group">
                        <label>Date Range:</label>
                        <RangePicker
                          value={range}
                          onChange={setRange}
                          size="middle"
                          style={{ width: '100%' }}
                        />
                      </div>
                    </CCol>
                    <CCol md={4}>
                      <CButton
                        color="primary"
                        onClick={() => getReportData()}
                        style={{ marginBottom: '8px', marginLeft: '1%' }}
                      >
                        Search
                      </CButton>
                      {/* {Base.hasRights('Export Overtime Report') && (
                        <CButton
                          color="success"
                          onClick={onDownload}
                          style={{ marginBottom: '20px', marginTop: '20px', marginLeft: '1%' }}
                          className="text-white"
                        >
                          Export
                        </CButton>
                      )} */}
                    </CCol>
                  </CRow>

                  <br />
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
        <br />
        <br />
        <CRow>
          <CCol md={12}>
            <table className="table table-bordered data-table" ref={tableRef}>
              {isLoading ? (
                Loading
              ) : (
                <>
                  {reportData.length > 0 ? (
                    <DataReportTable
                      reportData={reportData}
                      setReportData={(data) => setReportData(data)}
                      isLoading={isLoading}
                      ref={tableRef}
                    />
                  ) : (
                    <tbody>
                      <tr
                        style={{
                          border: 0,
                          fontWeight: 'bold',
                          textAlign: 'center',
                          fontSize: '19px',
                        }}
                      >
                        <td>No record to show...</td>
                      </tr>
                    </tbody>
                  )}
                </>
              )}
            </table>
          </CCol>
        </CRow>
      </div>
    </>
  )
}
